import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["header", "scrollToTop", "starting"]

  connect() {
    console.log("connect body controller", this.element)

    // document click handler for links' behaviour
    this.clickHandler = (event) => {
      const element = event.target
      const tagname = element.tagName.toLowerCase()

      if (tagname === "a" &&
          (location.hostname === element.hostname || !element.hostname.length)) {

        const anchor = element.href.split("#").pop()
        const target = document.getElementById(element.href.split("#").pop())

        if (anchor && target) {
          event.preventDefault()
          this.scrollTo(target, `#${anchor}`)
        }
      } else if (tagname === "a" && location.hostname !== element.hostname) {
        event.preventDefault()
        window.open(element.href, "_blank")
      }
    }

    this.element.addEventListener("click", this.clickHandler)

    // oberserver to control display of scrollToTopButton
    const headerObserver = new IntersectionObserver((entries) => {

      if (entries[0].intersectionRatio == 0) {
        this.scrollToTop(true)
      } else {
        this.scrollToTop(false)
      }
    })

    if (this.hasHeaderTarget) {
      headerObserver.observe(this.headerTarget)
    }

    // jump to starting point when screen size is < sm and location has no hash
    if (this.hasStartingTarget && this.matchMedia("lt-sm") && !location.hash) {
      this.scrollTo(this.startingTarget)
    }
  }

  disconnect() {
    this.element.removeEventListener("click", this.clickHandler)
  }

  scrollTo(target, url = false) {
    window.setTimeout(() => {
      const position = target.offsetTop
      const layout = document.querySelector(".layout")
      const offset = layout ? 
        parseFloat(window.getComputedStyle(layout).getPropertyValue("padding-top")) : 0

      window.scrollTo({
        top: position - offset,
        behavior: "smooth"
      })

      if (url) {
        history.replaceState(null, null, url)
      }
    }, 50)
  }

  scrollToTop(active) {
    
    if (active && !this.hasScrollToTopTarget) {
      const element = document.createElement("button")
      element.classList.add("scroll-to-top")
      element.setAttribute("data-body-target", "scrollToTop")

      element.addEventListener("click", (event) => {
        event.preventDefault()
        this.scrollTo(document.body)
      })

      this.element.appendChild(element)
    } else if (!active && this.hasScrollToTopTarget) {
      this.scrollToTopTarget.parentNode.removeChild(this.scrollToTopTarget)
    }
  }

  matchMedia(size) {
    const sizes = {
      "sm": "(min-width: 601px)",
      "lt-sm": "(max-width: 600px)"
    }

    const match = window.matchMedia(sizes[size])
    return match.matches
  }
}
